usedOperationName